import { ScreenSize } from '@/app/constants'

export const getPageRightOffset = (breakpoint: ScreenSize) => {
  if ([ScreenSize.Xxs, ScreenSize.Xs].includes(breakpoint)) {
    return 16
  }

  if (breakpoint === ScreenSize.Xl) {
    return 30
  }

  return 24
}
